var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logotype"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Logo",
    d: "M13.5108 13.4441L5.46289 21.9861C5.46319 21.9878 5.4638 21.9893 5.4641 21.9911C5.71091 22.9186 6.55807 23.6016 7.56352 23.6016C7.96545 23.6016 8.3428 23.4929 8.66641 23.3021L8.69211 23.2871L17.7511 18.0597L13.5108 13.4441Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Logo_2",
    d: "M21.653 11.9899L21.6453 11.9846L17.7343 9.71733L13.3281 13.6381L17.7497 18.0591L21.64 15.8144C22.3221 15.4462 22.7851 14.7271 22.7851 13.898C22.7851 13.0748 22.3283 12.3593 21.653 11.9899Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Logo_3",
    d: "M5.46443 5.77413C5.41605 5.95252 5.39062 6.13939 5.39062 6.33343V21.4274C5.39062 21.6211 5.41575 21.8086 5.46474 21.9863L13.7896 13.6629L5.46443 5.77413Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Logo_4",
    d: "M13.5705 13.8804L17.736 9.716L8.68735 4.46975C8.35845 4.27275 7.97459 4.15906 7.56382 4.15906C6.55837 4.15906 5.71008 4.84325 5.46319 5.7719C5.46289 5.77281 5.46289 5.77341 5.46289 5.77424L13.5705 13.8804Z",
    fill: "#4CAF50"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.cd51081a6fa9d58b7b334bd4a351d1b6.svg";
export { ForwardRef as ReactComponent };